import _get from 'lodash/get';

import { Base } from '@/models';
import _castArray from 'lodash/castArray';
import { toCamelCase } from '@/utilities';

export class PaymentDetail extends Base {
  public amount: string;
  public paymentdate: string;
  /**
   * Constructor initialises the variables from the class Fee
   * @param data - the data to construct a type with all properties of <Fee>
   */
  public constructor(data?: Partial<PaymentDetail>) {
    super(data);
    data = toCamelCase(data);
    this.amount = _get(data, 'amount', '');
    this.paymentdate = _get(data, 'paymentdate', '');
  }
  /**
  * Create a JSON representation of this object and it's descedents.
  *
  * @return {Object}
  */
  public toJSON() {
    const json = super.toJSON();
    // Convert the populated Client to the Client ID
    return {
      ...json,
    };
  }

}
